import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=cc716772&scoped=true"
import script from "./InfoBanner.vue?vue&type=script&lang=js"
export * from "./InfoBanner.vue?vue&type=script&lang=js"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=cc716772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc716772",
  null
  
)

export default component.exports